/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewbuildingLayoutsDesktopFicheringModel,
  IGetNewbuildingLayoutsDesktopFicheringRequest,
  IMappers,
  IGetNewbuildingLayoutsDesktopFicheringResponse,
  IGetNewbuildingLayoutsDesktopFicheringResponseError,
  TGetNewbuildingLayoutsDesktopFicheringResponse,
} from './types';

const defaultConfig: TGetNewbuildingLayoutsDesktopFicheringModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'newbuilding-card',
  pathApi: '/v1/get-newbuilding-layouts-desktop-fichering/',
  hostType: 'api',
} as TGetNewbuildingLayoutsDesktopFicheringModel;

function createGetNewbuildingLayoutsDesktopFicheringModel(
  parameters: IGetNewbuildingLayoutsDesktopFicheringRequest,
): TGetNewbuildingLayoutsDesktopFicheringModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingLayoutsDesktopFicheringOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewbuildingLayoutsDesktopFicheringRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewbuildingLayoutsDesktopFichering<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewbuildingLayoutsDesktopFicheringOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetNewbuildingLayoutsDesktopFicheringResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createGetNewbuildingLayoutsDesktopFicheringModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingLayoutsDesktopFicheringResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingLayoutsDesktopFicheringResponseError);
    }
  }

  return { response, statusCode } as TGetNewbuildingLayoutsDesktopFicheringResponse;
}

export { defaultConfig, createGetNewbuildingLayoutsDesktopFicheringModel, fetchGetNewbuildingLayoutsDesktopFichering };
